import { html, classMap } from '@resn/gozer-core';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';

import { isArray } from 'underscore';
import { autobind } from 'core-decorators';
import { COLORS } from 'core/constants';
import svg from 'component/svg';

import './index.scss';

const template = ({ props, options, context }) => html`
    <button
        data-ui="btn"
        class="btnMain"
        @click=${context.onClick}
        ?disabled=${props.disabled}
        ?active=${props.active}
        ?icon=${props.iconId}
    >
        <span data-ui="bg" class="btnMain__bg" ?disabled=${props.disabled}>
            ${options.rolloverGradient
                ? html`<span data-ui="rolloverGradient" class="btnMain__rolloverGradient"></span>`
                : ''}
        </span>

        <span class="btnMain__content">
            <span class="btnMain__text">${props.text}</span>
            ${props.iconId ? svg(props.iconId, 'btnMain__icon', 'icon') : ''}
        </span>
    </button>
`;

@componentMixin(DomComponentMixin)
class BtnMain extends Component {
    options = {
        template,
        className: '',
        small: false,
        rolloverGradient: null,
        gradientAngle: 90,
        onClick: () => {},
    };

    props = {
        active: true,
        disabled: false,

        text: 'Button main',
        textColor: 'white',
        iconId: 'arrowhead-right',
        bgColor: COLORS.DARK_BLUE,
        bgAlpha: 1,
        style: (props) => ({ textColor: props.textColor, bgColor: props.bgColor, bgAlpha: props.bgAlpha }),
    };

    async onSetup() {
        const { className, small, rolloverGradient, gradientAngle } = this.options;

        if (className) this.el.classList.add(className);
        if (small) this.el.classList.add('btnMain--small');

        if (isArray(rolloverGradient)) {
            const gradient = `linear-gradient(${gradientAngle}deg, ${rolloverGradient[0]},${rolloverGradient[1]},${rolloverGradient[0]},${rolloverGradient[1]}, ${rolloverGradient[0]})`;
            this.ui.rolloverGradient.style.background = gradient;
        }
    }

    setBgColor(val) {
        // this.ui.bg.style.backgroundColor = val;
        this.el.style.setProperty('--bg-color', val);
    }

    setTextColor(val) {
        // this.el.style.color = val;
        this.el.style.setProperty('--text-color', val);
    }

    setBgAlpha(alpha) {
        this.ui.bg.style.opacity = alpha;
    }

    @autobind
    onClick(evt) {
        this.options.onClick(evt);
    }
}

export default BtnMain;
